import {
  Box,
  Button,
  Card,
  CardMedia,
  CardActions,
  CardContent,
  Typography,
  Chip,
  Tooltip,
} from '@mui/material';
import siloMetrixIcon from '@old/assets/svg/SiloBagPage/silo-metrix-active.svg';
import { formatNumberWithSeparators } from '@old/utils/helper';
import { InsuranceRusModal } from './insurance-modals/rus-modal';
import { useState } from 'react';
import i18n from '../../libs/language';
import { GenericInsuranceModal } from './insurance-modals/generic-insurance-modal';

// TODO: esta interfaz se movió de otro lugar acá por comodidad para borrar archivos, pero habría que revisarla y migrarla al nuevo tipado.
export interface InsuranceCoverage_DEPRECATED {
  code: string;
  description: string;
}

// TODO: esta interfaz se movió de otro lugar acá por comodidad para borrar archivos, pero habría que revisarla y migrarla al nuevo tipado.
export interface InsuranceQuote_DEPRECATED {
  background_color: string;
  enabled: boolean;
  logo_url: string;
  logo_url_white: string;
  includes: InsuranceCoverage_DEPRECATED[];
  price: number;
  sum_assured: number;
  duration: number;
  description: string;
  siloMetrix: boolean;
  service_id: number;
  form_url: string;
}

type PriceData = {
  [key: number | string]: number;
};
type CardSiloInsuranceProps = {
  logoUrl: string;
  item: InsuranceQuote_DEPRECATED;
  silobagIds?: string[];
  silobagData: { id: string; species: number; speciesName: string; tons: number }[];
  vigency: number;
  priceData: PriceData;
  validationPrices: boolean;
  typeCoin: number;
};

enum InsuranceServiceID {
  LA_SEGUNDA = 5,
  RUS = 6,
  GALICIA = 8,
  FED_PATRONAL = 9,
  SWISS_RE = 10,
}

export function CardSiloInsurance(props: CardSiloInsuranceProps) {
  const { logoUrl, item, silobagIds, vigency, priceData, validationPrices, typeCoin, silobagData } = props;

  const [openRus, setOpenRus] = useState(false);
  const [openLaSegunda, setOpenLaSegunda] = useState(false);
  const [openGalicia, setOpenGalicia] = useState(false);
  const [openFedPatronal, setOpenFedPatronal] = useState(false);
  const [openSwissRe, setOpenSwissRe] = useState(false);

  const handleOpenInsurance = () => {
    if (item.service_id === InsuranceServiceID.LA_SEGUNDA) setOpenLaSegunda(true);
    if (item.service_id === InsuranceServiceID.RUS) setOpenRus(true);
    if (item.service_id === InsuranceServiceID.GALICIA) setOpenGalicia(true);
    if (item.service_id === InsuranceServiceID.FED_PATRONAL) setOpenFedPatronal(true);
    if (item.service_id === InsuranceServiceID.SWISS_RE) setOpenSwissRe(true);
  };
  return (
    <Box>
      <Typography
        variant="h6"
        style={{ fontWeight: 500, textAlign: 'center', display: 'flex', alignItems: 'center' }}
      >
        {i18n.t('app.silobag_insurance.with')}{' '}
        {item.siloMetrix ? (
          <div style={{ color: 'orange', fontSize: '14px', marginLeft: '5px' }}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={siloMetrixIcon} alt="SiloMetrixicon" style={{ marginRight: '3px', width: '18px' }} />
              SILO<span style={{ fontWeight: 600 }}>METRIX</span>{' '}
              <Chip
                label="50%"
                color="success"
                sx={{
                  marginLeft: '5px',
                  fontSize: '12px',
                  height: '20px',
                  width: '60px',
                  backgroundColor: '#D9EFB4',
                  color: '#6baa00',
                  fontWeight: 600,
                  borderRadius: '10px',
                }}
              />
            </span>
          </div>
        ) : (
          i18n.t('app.silobag_insurance.your_plan')
        )}
      </Typography>
      <Card sx={{ width: 256, margin: '14px auto' }}>
        <Box
          sx={{
            backgroundColor: item.enabled ? item.background_color : '#C4C3C4',
            height: 70,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CardMedia
            sx={{
              height: item.service_id === InsuranceServiceID.FED_PATRONAL ? 52 : 35,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
            image={logoUrl}
            title="Logo-Insurance"
            style={{ width: '100%', maxHeight: '300px' }}
          />
        </Box>
        <CardContent sx={{ height: '150px' }}>
          {item.service_id == InsuranceServiceID.RUS ? (
            <Box>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                style={{ color: item.enabled ? 'black' : '#C4C3C4', textAlign: 'center' }}
              >
                <span
                  style={{
                    display: 'block',
                    fontSize: '15px',
                    color: item.enabled ? item.background_color : '#C4C3C4',
                    fontWeight: 500,
                    marginBottom: '10px',
                  }}
                >
                  {i18n.t('app.silobag_insurance.thirds_complete')}
                </span>
                $ {formatNumberWithSeparators(item.price)}
              </Typography>
              <hr />
              <Typography
                variant="body2"
                // color="text.secondary"
                style={{ color: item.enabled ? 'black' : '#C4C3C4', textAlign: 'center' }}
              >
                <span style={{ display: 'block' }}>{i18n.t('app.silobag_insurance.sum_assured')}</span>${' '}
                {formatNumberWithSeparators(item.sum_assured)}
              </Typography>
            </Box>
          ) : (
            <Box>
              {' '}
              <Typography
                gutterBottom
                variant="h6"
                component="div"
                style={{
                  color: item.enabled ? 'black' : '#C4C3C4',
                  textAlign: 'center',
                  fontSize: '18px',
                  marginTop: '10px',
                }}
              >
                {i18n.t('app.silobag_insurance.provide_details_for_custom_quote')}
              </Typography>
            </Box>
          )}
        </CardContent>
        <CardActions>
          <Tooltip title={validationPrices ? '' : i18n.t('app.silobag_insurance.enter_price')}>
            <Box sx={{ width: '100%' }}>
              <Button
                variant="outlined"
                color="info"
                sx={{ borderRadius: 100, width: '95%' }}
                disabled={!item.enabled || !validationPrices}
                onClick={handleOpenInsurance}
              >
                {i18n.t('app.silobag_insurance.view_detail')}
              </Button>
            </Box>
          </Tooltip>
        </CardActions>
      </Card>
      {openLaSegunda && (
        <GenericInsuranceModal
          type="lasegunda"
          open={openLaSegunda}
          setOpen={setOpenLaSegunda}
          silobagIds={silobagIds}
          silobagData={silobagData}
          vigency={vigency}
          priceData={priceData}
          typeCoin={typeCoin}
        />
      )}
      {openGalicia && (
        <GenericInsuranceModal
          type="galicia"
          open={openGalicia}
          setOpen={setOpenGalicia}
          silobagIds={silobagIds}
          silobagData={silobagData}
          vigency={vigency}
          priceData={priceData}
          typeCoin={typeCoin}
        />
      )}
      {openFedPatronal && (
        <GenericInsuranceModal
          type="fedpatronal"
          open={openFedPatronal}
          setOpen={setOpenFedPatronal}
          silobagIds={silobagIds}
          silobagData={silobagData}
          vigency={vigency}
          priceData={priceData}
          typeCoin={typeCoin}
        />
      )}
      {openRus && (
        <InsuranceRusModal open={openRus} setOpen={setOpenRus} data={item} silobagId={silobagIds} />
      )}
      {openSwissRe && (
        <GenericInsuranceModal
          type="swissre"
          open={openSwissRe}
          setOpen={setOpenSwissRe}
          silobagIds={silobagIds}
          silobagData={silobagData}
          vigency={vigency}
          priceData={priceData}
          typeCoin={typeCoin}
        />
      )}
    </Box>
  );
}
